export const cfop = [
  {
    code: 1100,
    text: "COMPRAS PARA INDUSTRIALIZAÇÃO, COMERCIALIZAÇÃO OU PRESTAÇÃO DE SERVIÇOS",
  },
  {
    code: 1101,
    text: "Compra para industrialização ou produção rural",
  },
  {
    code: 1102,
    text: "Compra para comercialização",
  },
  {
    code: 1111,
    text: "Compra para industrialização de mercadoria recebida anteriormente em consignação industrial",
  },
  {
    code: 1113,
    text: "Compra para comercialização, de mercadoria recebida anteriormente em consignação mercantil",
  },
  {
    code: 1116,
    text: "Compra para industrialização ou produção rural originada de encomenda para recebimento futuro",
  },
  {
    code: 1117,
    text: "Compra para comercialização originada de encomenda para recebimento futuro",
  },
  {
    code: 1118,
    text: "Compra de mercadoria para comercialização pelo adquirente originário, entregue pelo vendedor remetente ao destinatário, em venda à ordem",
  },
  {
    code: 1120,
    text: "Compra para industrialização, em venda à ordem, já recebida do vendedor remetente",
  },
  {
    code: 1121,
    text: "Compra para comercialização, em venda à ordem, já recebida do vendedor remetente",
  },
  {
    code: 1122,
    text: "Compra para industrialização em que a mercadoria foi remetida pelo fornecedor ao industrializador sem transitar pelo estabelecimento adquirente",
  },
  {
    code: 1124,
    text: "Industrialização efetuada por outra empresa",
  },
  {
    code: 1125,
    text: "Industrialização efetuada por outra empresa quando a mercadoria remetida para utilização no processo de industrialização não transitou pelo estabelecimento adquirente da mercadoria",
  },
  {
    code: 1126,
    text: "compras para utilização na prestação de serviços sujeitas ao ICMS",
  },
  {
    code: 1128,
    text: "compras para utilização na prestação de serviços sujeitas ao ISSQN",
  },
  {
    code: 1150,
    text: "TRANSFERÊNCIAS PARA INDUSTRIALIZAÇÃO, COMERCIALIZAÇÃO OU PRESTAÇÃO DE SERVIÇOS",
  },
  {
    code: 1151,
    text: "Transferência para industrialização ou produção rural",
  },
  {
    code: 1152,
    text: "Transferência para comercialização",
  },
  {
    code: 1153,
    text: "Transferência de energia elétrica para distribuição",
  },
  {
    code: 1154,
    text: "Transferência para utilização na prestação de serviço",
  },
  {
    code: 1200,
    text: "DEVOLUÇÕES DE VENDAS DE PRODUÇÃO PRÓPRIA, DE TERCEIROS OU ANULAÇÕES DE VALORES",
  },
  {
    code: 1201,
    text: "Devolução de venda de produção do estabelecimento",
  },
  {
    code: 1202,
    text: "Devolução de venda de mercadoria adquirida ou recebida de terceiros",
  },
  {
    code: 1203,
    text: "Devolução de venda de produção do estabelecimento, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio",
  },
  {
    code: 1204,
    text: "Devolução de venda de mercadoria adquirida ou recebida de terceiros, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio",
  },
  {
    code: 1205,
    text: "Anulação de valor relativo à prestação de serviço de comunicação",
  },
  {
    code: 1206,
    text: "Anulação de valor relativo à prestação de serviço de transporte",
  },
  {
    code: 1207,
    text: "Anulação de valor relativo à venda de energia elétrica",
  },
  {
    code: 1208,
    text: "Devolução de produção do estabelecimento, remetida em transferência",
  },
  {
    code: 1209,
    text: "Devolução de mercadoria adquirida ou recebida de terceiros, remetida em transferência",
  },
  {
    code: 1250,
    text: "COMPRAS DE ENERGIA ELÉTRICA",
  },
  {
    code: 1251,
    text: "Compra de energia elétrica para distribuição ou comercialização",
  },
  {
    code: 1252,
    text: "Compra de energia elétrica por estabelecimento industrial",
  },
  {
    code: 1253,
    text: "Compra de energia elétrica por estabelecimento comercial",
  },
  {
    code: 1254,
    text: "Compra de energia elétrica por estabelecimento prestador de serviço de transporte",
  },
  {
    code: 1255,
    text: "Compra de energia elétrica por estabelecimento prestador de serviço de comunicação",
  },
  {
    code: 1256,
    text: "Compra de energia elétrica por estabelecimento de produtor rural",
  },
  {
    code: 1257,
    text: "Compra de energia elétrica para consumo por demanda contratada",
  },
  {
    code: 1300,
    text: "AQUISIÇÕES DE SERVIÇOS DE COMUNICAÇÃO",
  },
  {
    code: 1301,
    text: "Aquisição de serviço de comunicação para execução de serviço da mesma natureza",
  },
  {
    code: 1302,
    text: "Aquisição de serviço de comunicação por estabelecimento industrial",
  },
  {
    code: 1303,
    text: "Aquisição de serviço de comunicação por estabelecimento comercial",
  },
  {
    code: 1304,
    text: "Aquisição de serviço de comunicação por estabelecimento de prestador de serviço de transporte",
  },
  {
    code: 1305,
    text: "Aquisição de serviço de comunicação por estabelecimento de geradora ou de distribuidora de energia elétrica 1.306 - Aquisição de serviço de comunicação por estabelecimento de produtor rural",
  },
  {
    code: 1350,
    text: "AQUISIÇÕES DE SERVIÇOS DE TRANSPORTE",
  },
  {
    code: 1351,
    text: "Aquisição de serviço de transporte para execução de serviço da mesma natureza",
  },
  {
    code: 1352,
    text: "Aquisição de serviço de transporte por estabelecimento industrial",
  },
  {
    code: 1353,
    text: "Aquisição de serviço de transporte por estabelecimento comercial",
  },
  {
    code: 1354,
    text: "Aquisição de serviço de transporte por estabelecimento de prestador de serviço de comunicação",
  },
  {
    code: 1355,
    text: "Aquisição de serviço de transporte por estabelecimento de geradora ou de distribuidora de energia elétrica",
  },
  {
    code: 1356,
    text: "Aquisição de serviço de transporte por estabelecimento de produtor rural",
  },
  {
    code: 1360,
    text: "Aquisição de serviço de transporte por contribuinte substituto em relação ao serviço de transporte",
  },
  {
    code: 1400,
    text: "ENTRADAS DE MERCADORIAS SUJEITAS AO REGIME DE SUBSTITUIÇÃO TRIBUTÁRIA",
  },
  {
    code: 1401,
    text: "Compra para industrialização ou produção rural em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 1403,
    text: "Compra para comercialização em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 1406,
    text: "Compra de bem para o ativo imobilizado cuja mercadoria está sujeita ao regime de substituição tributária",
  },
  {
    code: 1407,
    text: "Compra de mercadoria para uso ou consumo cuja mercadoria está sujeita ao regime de substituição tributária",
  },
  {
    code: 1408,
    text: "Transferência para industrialização ou produção rural em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 1409,
    text: "Transferência para comercialização em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 1410,
    text: "Devolução de venda de produção do estabelecimento em operação com produto sujeito ao regime de substituição tributária",
  },
  {
    code: 1411,
    text: "Devolução de venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária 1.414 - Retorno de produção do estabelecimento, remetida para venda fora do estabelecimento em operação com  produto sujeito ao regime de substituição tributária",
  },
  {
    code: 1415,
    text: "Retorno de mercadoria adquirida ou recebida de terceiros, remetida para venda fora do estabelecimento em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 1450,
    text: "SISTEMAS DE INTEGRAÇÃO",
  },
  {
    code: 1451,
    text: "Retorno de animal do estabelecimento produtor",
  },
  {
    code: 1452,
    text: "Retorno de insumo não utilizado na produção",
  },
  {
    code: 1500,
    text: "ENTRADAS DE MERCADORIAS REMETIDAS COM FIM ESPECÍFICO DE EXPORTAÇÃO E EVENTUAIS DEVOLUÇÕES",
  },
  {
    code: 1501,
    text: "Entrada de mercadoria recebida com fim específico de exportação",
  },
  {
    code: 1503,
    text: "Entrada decorrente de devolução de produto remetido com fim específico de exportação, de produção do estabelecimento",
  },
  {
    code: 1504,
    text: "Entrada decorrente de devolução de mercadoria remetida com fim específico de exportação, adquirida ou recebida de terceiros",
  },
  {
    code: 1505,
    text: "Entrada decorrente de devolução simbólica de mercadorias remetidas para formação de lote de exportação, de produtos industrializados ou produzidos pelo próprio estabelecimento",
  },
  {
    code: 1506,
    text: "Entrada decorrente de devolução simbólica de mercadorias, adquiridas ou recebidas de terceiros, remetidas para formação de lote de exportação",
  },
  {
    code: 1550,
    text: "OPERAÇÕES COM BENS DE ATIVO IMOBILIZADO E MATERIAIS PARA USO OU CONSUMO",
  },
  {
    code: 1551,
    text: "Compra de bem para o ativo imobilizado",
  },
  {
    code: 1552,
    text: "Transferência de bem do ativo imobilizado",
  },
  {
    code: 1553,
    text: "Devolução de venda de bem do ativo imobilizado",
  },
  {
    code: 1554,
    text: "Retorno de bem do ativo imobilizado remetido para uso fora do estabelecimento",
  },
  {
    code: 1555,
    text: "Entrada de bem do ativo imobilizado de terceiro, remetido para uso no estabelecimento",
  },
  {
    code: 1556,
    text: "Compra de material para uso ou consumo",
  },
  {
    code: 1557,
    text: "Transferência de material para uso ou consumo",
  },
  {
    code: 1600,
    text: "CRÉDITOS E RESSARCIMENTOS DE ICMS",
  },
  {
    code: 1601,
    text: "Recebimento, por transferência, de crédito de ICMS",
  },
  {
    code: 1602,
    text: "Recebimento, por transferência, de saldo credor de ICMS de outro estabelecimento da mesma empresa, para compensação de saldo devedor de ICMS",
  },
  {
    code: 1603,
    text: "Ressarcimento de ICMS retido por substituição tributária 1.604 - Lançamento do crédito relativo à compra de bem para o ativo imobilizado",
  },
  {
    code: 1605,
    text: "Recebimento, por transferência, de saldo devedor de ICMS de outro estabelecimento da mesma empresa",
  },
  {
    code: 1652,
    text: "Compra de combustível ou lubrificante para comercialização",
  },
  {
    code: 1653,
    text: "Compra de combustível ou lubrificante por consumidor ou usuário final",
  },
  {
    code: 1658,
    text: "Transferência de combustível e lubrificante para industrialização",
  },
  {
    code: 1659,
    text: "Transferência de combustível e lubrificante para comercialização",
  },
  {
    code: 1660,
    text: "Devolução de venda de combustível ou lubrificante destinado à industrialização subseqüente",
  },
  {
    code: 1661,
    text: "Devolução de venda de combustível ou lubrificante destinado à comercialização",
  },
  {
    code: 1662,
    text: "Devolução de venda de combustível ou lubrificante destinado a consumidor ou usuário final",
  },
  {
    code: 1663,
    text: "Entrada de combustível ou lubrificante para armazenagem",
  },
  {
    code: 1664,
    text: "Retorno de combustível ou lubrificante remetido para armazenagem",
  },
  {
    code: 1900,
    text: "OUTRAS ENTRADAS DE MERCADORIAS OU AQUISIÇÕES DE SERVIÇOS",
  },
  {
    code: 1901,
    text: "Entrada para industrialização por encomenda",
  },
  {
    code: 1902,
    text: "Retorno de mercadoria remetida para industrialização por encomenda",
  },
  {
    code: 1903,
    text: "Entrada de mercadoria remetida para industrialização e não aplicada no referido processo",
  },
  {
    code: 1904,
    text: "Retorno de remessa para venda fora do estabelecimento",
  },
  {
    code: 1905,
    text: "Entrada de mercadoria recebida para depósito em depósito fechado ou armazém geral",
  },
  {
    code: 1906,
    text: "Retorno de mercadoria remetida para depósito fechado ou armazém geral",
  },
  {
    code: 1907,
    text: "Retorno simbólico de mercadoria remetida para depósito fechado ou armazém geral",
  },
  {
    code: 1908,
    text: "Entrada de bem por conta de contrato de comodato",
  },
  {
    code: 1909,
    text: "Retorno de bem remetido por conta de contrato de comodato",
  },
  {
    code: 1910,
    text: "Entrada de bonificação, doação ou brinde",
  },
  {
    code: 1911,
    text: "Entrada de amostra grátis",
  },
  {
    code: 1912,
    text: "Entrada de mercadoria ou bem recebido para demonstração",
  },
  {
    code: 1913,
    text: "Retorno de mercadoria ou bem remetido para demonstração",
  },
  {
    code: 1914,
    text: "Retorno de mercadoria ou bem remetido para exposição ou feira",
  },
  {
    code: 1915,
    text: "Entrada de mercadoria ou bem recebido para conserto ou reparo",
  },
  {
    code: 1916,
    text: "Retorno de mercadoria ou bem remetido para conserto ou reparo",
  },
  {
    code: 1917,
    text: "Entrada de mercadoria recebida em consignação mercantil ou industrial",
  },
  {
    code: 1918,
    text: "Devolução de mercadoria remetida em consignação mercantil ou industrial",
  },
  {
    code: 1919,
    text: "Devolução simbólica de mercadoria vendida ou utilizada em processo industrial, remetida anteriormente em consignação mercantil ou industrial",
  },
  {
    code: 1920,
    text: "Entrada de vasilhame ou sacaria",
  },
  {
    code: 1921,
    text: "Retorno de vasilhame ou sacaria",
  },
  {
    code: 1922,
    text: "Lançamento efetuado a título de simples faturamento decorrente de compra para recebimento futuro",
  },
  {
    code: 1923,
    text: "Entrada de mercadoria recebida do vendedor remetente, em venda à ordem",
  },
  {
    code: 1924,
    text: "Entrada para industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente",
  },
  {
    code: 1925,
    text: "Retorno de mercadoria remetida para industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente",
  },
  {
    code: 1926,
    text: "Lançamento efetuado a título de reclassificação de mercadoria decorrente de formação de kit ou de sua desagregação",
  },
  {
    code: 1931,
    text: "Lançamento efetuado pelo tomador do serviço de transporte quando a responsabilidade de retenção do imposto for atribuída ao remetente ou alienante da mercadoria, pelo serviço de transporte realizado por transportador autônomo ou por transportador não inscrito na unidade da Federação onde iniciado o serviço",
  },
  {
    code: 1932,
    text: "Aquisição de serviço de transporte iniciado em unidade da Federação diversa daquela onde inscrito o prestador",
  },
  {
    code: 1933,
    text: "Aquisição de serviço tributado pelo ISSQN",
  },
  {
    code: 1949,
    text: "Outra entrada de mercadoria ou prestação de serviço não especificada",
  },
  {
    code: 2000,
    text: "ENTRADAS OU AQUISIÇÕES DE SERVIÇOS DE OUTROS ESTADOS",
  },
  {
    code: 2100,
    text: "COMPRAS PARA INDUSTRIALIZAÇÃO, COMERCIALIZAÇÃO OU PRESTAÇÃO DE SERVIÇOS",
  },
  {
    code: 2101,
    text: "Compra para industrialização ou produção rural",
  },
  {
    code: 2102,
    text: "Compra para comercialização",
  },
  {
    code: 2111,
    text: "Compra para industrialização de mercadoria recebida anteriormente em consignação industrial",
  },
  {
    code: 2113,
    text: "Compra para comercialização, de mercadoria recebida anteriormente em consignação mercantil",
  },
  {
    code: 2116,
    text: "Compra para industrialização ou produção rural originada de encomenda para recebimento futuro",
  },
  {
    code: 2117,
    text: "Compra para comercialização originada de encomenda para recebimento futuro",
  },
  {
    code: 2118,
    text: "Compra de mercadoria para comercialização pelo adquirente originário, entregue pelo vendedor remetente ao destinatário, em venda à ordem",
  },
  {
    code: 2120,
    text: "Compra para industrialização, em venda à ordem, já recebida do vendedor remetente 2.121 - Compra para comercialização, em venda à ordem, já recebida do vendedor remetente",
  },
  {
    code: 2122,
    text: "Compra para industrialização em que a mercadoria foi remetida pelo fornecedor ao industrializador sem transitar pelo estabelecimento adquirente",
  },
  {
    code: 2124,
    text: "Industrialização efetuada por outra empresa",
  },
  {
    code: 2125,
    text: "Industrialização efetuada por outra empresa quando a mercadoria remetida para utilização no processo de industrialização não transitou pelo estabelecimento adquirente da mercadoria",
  },
  {
    code: 2126,
    text: "Compra para utilização na prestação de serviço",
  },
  {
    code: 2150,
    text: "TRANSFERÊNCIAS PARA INDUSTRIALIZAÇÃO, COMERCIALIZAÇÃO OU PRESTAÇÃO DE SERVIÇOS",
  },
  {
    code: 2151,
    text: "Transferência para industrialização ou produção rural",
  },
  {
    code: 2152,
    text: "Transferência para comercialização",
  },
  {
    code: 2153,
    text: "Transferência de energia elétrica para distribuição",
  },
  {
    code: 2154,
    text: "Transferência para utilização na prestação de serviço",
  },
  {
    code: 2200,
    text: "DEVOLUÇÕES DE VENDAS DE PRODUÇÃO PRÓPRIA, DE TERCEIROS OU ANULAÇÕES DE VALORES",
  },
  {
    code: 2201,
    text: "Devolução de venda de produção do estabelecimento",
  },
  {
    code: 2202,
    text: "Devolução de venda de mercadoria adquirida ou recebida de terceiros",
  },
  {
    code: 2203,
    text: "Devolução de venda de produção do estabelecimento, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio",
  },
  {
    code: 2204,
    text: "Devolução de venda de mercadoria adquirida ou recebida de terceiros, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio",
  },
  {
    code: 2205,
    text: "Anulação de valor relativo à prestação de serviço de comunicação",
  },
  {
    code: 2206,
    text: "Anulação de valor relativo à prestação de serviço de transporte",
  },
  {
    code: 2207,
    text: "Anulação de valor relativo à venda de energia elétrica",
  },
  {
    code: 2208,
    text: "Devolução de produção do estabelecimento, remetida em transferência",
  },
  {
    code: 2209,
    text: "Devolução de mercadoria adquirida ou recebida de terceiros, remetida em transferência ",
  },
  {
    code: 2250,
    text: "COMPRAS DE ENERGIA ELÉTRICA",
  },
  {
    code: 2251,
    text: "Compra de energia elétrica para distribuição ou comercialização",
  },
  {
    code: 2252,
    text: "Compra de energia elétrica por estabelecimento industrial",
  },
  {
    code: 2253,
    text: "Compra de energia elétrica por estabelecimento comercial",
  },
  {
    code: 2254,
    text: "Compra de energia elétrica por estabelecimento prestador de serviço de transporte",
  },
  {
    code: 2255,
    text: "Compra de energia elétrica por estabelecimento prestador de serviço de comunicação",
  },
  {
    code: 2256,
    text: "Compra de energia elétrica por estabelecimento de produtor rural",
  },
  {
    code: 2257,
    text: "Compra de energia elétrica para consumo por demanda contratada",
  },
  {
    code: 2300,
    text: "AQUISIÇÕES DE SERVIÇOS DE COMUNICAÇÃO",
  },
  {
    code: 2301,
    text: "Aquisição de serviço de comunicação para execução de serviço da mesma natureza",
  },
  {
    code: 2302,
    text: "Aquisição de serviço de comunicação por estabelecimento industrial",
  },
  {
    code: 2303,
    text: "Aquisição de serviço de comunicação por estabelecimento comercial",
  },
  {
    code: 2304,
    text: "Aquisição de serviço de comunicação por estabelecimento de prestador de serviço de transporte",
  },
  {
    code: 2305,
    text: "Aquisição de serviço de comunicação por estabelecimento de geradora ou de distribuidora de energia elétrica",
  },
  {
    code: 2306,
    text: "Aquisição de serviço de comunicação por estabelecimento de produtor rural",
  },
  {
    code: 2351,
    text: "Aquisição de serviço de transporte para execução de serviço da mesma natureza",
  },
  {
    code: 2352,
    text: "Aquisição de serviço de transporte por estabelecimento industrial",
  },
  {
    code: 2353,
    text: "Aquisição de serviço de transporte por estabelecimento comercial",
  },
  {
    code: 2354,
    text: "Aquisição de serviço de transporte por estabelecimento de prestador de serviço de comunicação",
  },
  {
    code: 2355,
    text: "Aquisição de serviço de transporte por estabelecimento de geradora ou de distribuidora de energia elétrica",
  },
  {
    code: 2356,
    text: "Aquisição de serviço de transporte por estabelecimento de produtor rural",
  },
  {
    code: 2400,
    text: "ENTRADAS DE MERCADORIAS SUJEITAS AO REGIME DE SUBSTITUIÇÃO TRIBUTÁRIA",
  },
  {
    code: 2401,
    text: "Compra para industrialização ou produção rural em operação com mercadoria sujeita ao regime desubstituição tributária",
  },
  {
    code: 2403,
    text: "Compra para comercialização em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 2406,
    text: "Compra de bem para o ativo imobilizado cuja mercadoria está sujeita ao regime de substituição tributária",
  },
  {
    code: 2407,
    text: "Compra de mercadoria para uso ou consumo cuja mercadoria está sujeita ao regime de substituição tributária",
  },
  {
    code: 2408,
    text: "Transferência para industrialização ou produção rural em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 2409,
    text: "Transferência para comercialização em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 2410,
    text: "Devolução de venda de produção do estabelecimento em operação com produto sujeito ao regime desubstituição tributária",
  },
  {
    code: 2411,
    text: "Devolução de venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 2414,
    text: "Retorno de produção do estabelecimento, remetida para venda fora do estabelecimento em operação com produto sujeito ao regime de substituição tributária",
  },
  {
    code: 2415,
    text: "Retorno de mercadoria adquirida ou recebida de terceiros, remetida para venda fora do estabelecimento em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 2500,
    text: "ENTRADAS DE MERCADORIAS REMETIDAS COM FIM ESPECÍFICO DE EXPORTAÇÃO E EVENTUAIS DEVOLUÇÕES",
  },
  {
    code: 2501,
    text: "Entrada de mercadoria recebida com fim específico de exportação",
  },
  {
    code: 2503,
    text: "Entrada decorrente de devolução de produto remetido com fim específico de exportação, de produção do estabelecimento",
  },
  {
    code: 2504,
    text: "Entrada decorrente de devolução de mercadoria remetida com fim específico de exportação, adquirida ou recebida de terceiros",
  },
  {
    code: 2505,
    text: "Entrada decorrente de devolução simbólica de mercadorias remetidas para formação de lote de exportação, de produtos industrializados ou produzidos pelo próprio estabelecimento",
  },
  {
    code: 2506,
    text: "Entrada decorrente de devolução simbólica de mercadorias, adquiridas ou recebidas de terceiros, remetidas para formação de lote de exportação",
  },
  {
    code: 2550,
    text: "OPERAÇÕES COM BENS DE ATIVO IMOBILIZADO E MATERIAIS PARA USO OU CONSUMO",
  },
  {
    code: 2551,
    text: "Compra de bem para o ativo imobilizado",
  },
  {
    code: 2552,
    text: "Transferência de bem do ativo imobilizado",
  },
  {
    code: 2553,
    text: "Devolução de venda de bem do ativo imobilizado",
  },
  {
    code: 2554,
    text: "Retorno de bem do ativo imobilizado remetido para uso fora do estabelecimento",
  },
  {
    code: 2555,
    text: "Entrada de bem do ativo imobilizado de terceiro, remetido para uso no estabelecimento",
  },
  {
    code: 2556,
    text: "Compra de material para uso ou consumo",
  },
  {
    code: 2557,
    text: "Transferência de material para uso ou consumo",
  },
  {
    code: 2600,
    text: "CRÉDITOS E RESSARCIMENTOS DE ICMS",
  },
  {
    code: 2603,
    text: "Ressarcimento de ICMS retido por substituição tributária",
  },
  {
    code: 2651,
    text: "Compra de combustível ou lubrificante para industrialização subseqüente",
  },
  {
    code: 2652,
    text: "Compra de combustível ou lubrificante para comercialização",
  },
  {
    code: 2653,
    text: "Compra de combustível ou lubrificante por consumidor ou usuário final",
  },
  {
    code: 2658,
    text: "Transferência de combustível e lubrificante para industrialização",
  },
  {
    code: 2659,
    text: "Transferência de combustível e lubrificante para comercialização",
  },
  {
    code: 2660,
    text: "Devolução de venda de combustível ou lubrificante destinado à industrialização subseqüente",
  },
  {
    code: 2661,
    text: "Devolução de venda de combustível ou lubrificante destinado à comercialização",
  },
  {
    code: 2662,
    text: "Devolução de venda de combustível ou lubrificante destinado a consumidor ou usuário final",
  },
  {
    code: 2663,
    text: "Entrada de combustível ou lubrificante para armazenagem",
  },
  {
    code: 2664,
    text: "Retorno de combustível ou lubrificante remetido para armazenagem ",
  },
  {
    code: 2900,
    text: "OUTRAS ENTRADAS DE MERCADORIAS OU AQUISIÇÕES DE SERVIÇOS",
  },
  {
    code: 2901,
    text: "Entrada para industrialização por encomenda",
  },
  {
    code: 2902,
    text: "Retorno de mercadoria remetida para industrialização por encomenda",
  },
  {
    code: 2903,
    text: "Entrada de mercadoria remetida para industrialização e não aplicada no referido processo",
  },
  {
    code: 2904,
    text: "Retorno de remessa para venda fora do estabelecimento",
  },
  {
    code: 2905,
    text: "Entrada de mercadoria recebida para depósito em depósito fechado ou armazém geral",
  },
  {
    code: 2906,
    text: "Retorno de mercadoria remetida para depósito fechado ou armazém geral",
  },
  {
    code: 2907,
    text: "Retorno simbólico de mercadoria remetida para depósito fechado ou armazém geral",
  },
  {
    code: 2908,
    text: "Entrada de bem por conta de contrato de comodato",
  },
  {
    code: 2909,
    text: "Retorno de bem remetido por conta de contrato de comodato",
  },
  {
    code: 2910,
    text: "Entrada de bonificação, doação ou brinde",
  },
  {
    code: 2911,
    text: "Entrada de amostra grátis",
  },
  {
    code: 2912,
    text: "Entrada de mercadoria ou bem recebido para demonstração",
  },
  {
    code: 2913,
    text: "Retorno de mercadoria ou bem remetido para demonstração",
  },
  {
    code: 2914,
    text: "Retorno de mercadoria ou bem remetido para exposição ou feira",
  },
  {
    code: 2915,
    text: "Entrada de mercadoria ou bem recebido para conserto ou reparo",
  },
  {
    code: 2916,
    text: "Retorno de mercadoria ou bem remetido para conserto ou reparo",
  },
  {
    code: 2917,
    text: "Entrada de mercadoria recebida em consignação mercantil ou industrial",
  },
  {
    code: 2918,
    text: "Devolução de mercadoria remetida em consignação mercantil ou industrial",
  },
  {
    code: 2919,
    text: "Devolução simbólica de mercadoria vendida ou utilizada em processo industrial, remetida anteriormente em consignação mercantil ou industrial",
  },
  {
    code: 2920,
    text: "Entrada de vasilhame ou sacaria",
  },
  {
    code: 2921,
    text: "Retorno de vasilhame ou sacaria",
  },
  {
    code: 2922,
    text: "Lançamento efetuado a título de simples faturamento decorrente de compra para recebimento futuro",
  },
  {
    code: 2923,
    text: "Entrada de mercadoria recebida do vendedor remetente, em venda à ordem",
  },
  {
    code: 2924,
    text: "Entrada para industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente",
  },
  {
    code: 2925,
    text: "Retorno de mercadoria remetida para industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente",
  },
  {
    code: 2931,
    text: "Lançamento efetuado pelo tomador do serviço de transporte quando a responsabilidade de retenção do imposto for atribuída ao remetente ou alienante da mercadoria, pelo serviço de transporte realizado por transportador autônomo ou por transportador não inscrito na unidade da Federação onde iniciado o serviço",
  },
  {
    code: 2932,
    text: "Aquisição de serviço de transporte iniciado em unidade da Federação diversa daquela onde inscrito o prestador",
  },
  {
    code: 2933,
    text: "Aquisição de serviço tributado pelo ISSQN",
  },
  {
    code: 2949,
    text: "Outra entrada de mercadoria ou prestação de serviço não especificado ",
  },
  {
    code: 3000,
    text: "ENTRADAS OU AQUISIÇÕES DE SERVIÇOS DO EXTERIOR ",
  },
  {
    code: 3100,
    text: "COMPRAS PARA INDUSTRIALIZAÇÃO, COMERCIALIZAÇÃO OU PRESTAÇÃO DE SERVIÇOS",
  },
  {
    code: 3101,
    text: "Compra para industrialização ou produção rural",
  },
  {
    code: 3102,
    text: "Compra para comercialização",
  },
  {
    code: 3126,
    text: "Compra para utilização na prestação de serviço",
  },
  {
    code: 3127,
    text: "Compra para industrialização sob o regime de ",
  },
  {
    code: 3200,
    text: "DEVOLUÇÕES DE VENDAS DE PRODUÇÃO PRÓPRIA, DE TERCEIROS OU ANULAÇÕES DE VALORES",
  },
  {
    code: 3201,
    text: "Devolução de venda de produção do estabelecimento",
  },
  {
    code: 3202,
    text: "Devolução de venda de mercadoria adquirida ou recebida de terceiros",
  },
  {
    code: 3205,
    text: "Anulação de valor relativo à prestação de serviço de comunicação",
  },
  {
    code: 3206,
    text: "Anulação de valor relativo à prestação de serviço de transporte",
  },
  {
    code: 3207,
    text: "Anulação de valor relativo à venda de energia elétrica",
  },
  {
    code: 3211,
    text: "Devolução de venda de produção do estabelecimento sob o regime de ",
  },
  {
    code: 3250,
    text: "COMPRAS DE ENERGIA ELÉTRICA",
  },
  {
    code: 3251,
    text: "Compra de energia elétrica para distribuição ou comercialização ",
  },
  {
    code: 3300,
    text: "AQUISIÇÕES DE SERVIÇOS DE COMUNICAÇÃO",
  },
  {
    code: 3301,
    text: "Aquisição de serviço de comunicação para execução de serviço da mesma natureza ",
  },
  {
    code: 3350,
    text: "AQUISIÇÕES DE SERVIÇOS DE TRANSPORTE",
  },
  {
    code: 3351,
    text: "Aquisição de serviço de transporte para execução de serviço da mesma natureza",
  },
  {
    code: 3352,
    text: "Aquisição de serviço de transporte por estabelecimento industrial",
  },
  {
    code: 3353,
    text: "Aquisição de serviço de transporte por estabelecimento comercial",
  },
  {
    code: 3354,
    text: "Aquisição de serviço de transporte por estabelecimento de prestador de serviço de comunicação",
  },
  {
    code: 3355,
    text: "Aquisição de serviço de transporte por estabelecimento de geradora ou de distribuidora de energia elétrica",
  },
  {
    code: 3356,
    text: "Aquisição de serviço de transporte por estabelecimento de produtor rural ",
  },
  {
    code: 3500,
    text: "ENTRADAS DE MERCADORIAS REMETIDAS COM FIM ESPECÍFICO DE EXPORTAÇÃO E EVENTUAIS DEVOLUÇÕES",
  },
  {
    code: 3503,
    text: "Devolução de mercadoria exportada que tenha sido recebida com fim específico de exportação ",
  },
  {
    code: 3550,
    text: "OPERAÇÕES COM BENS DE ATIVO IMOBILIZADO E MATERIAIS PARA USO OU CONSUMO",
  },
  {
    code: 3551,
    text: "Compra de bem para o ativo imobilizado",
  },
  {
    code: 3553,
    text: "Devolução de venda de bem do ativo imobilizado",
  },
  {
    code: 3556,
    text: "Compra de material para uso ou consumo",
  },
  {
    code: 3651,
    text: "Compra de combustível ou lubrificante para industrialização subseqüente",
  },
  {
    code: 3652,
    text: "Compra de combustível ou lubrificante para comercialização",
  },
  {
    code: 3653,
    text: "Compra de combustível ou lubrificante por consumidor ou usuário final ",
  },
  {
    code: 3900,
    text: "OUTRAS ENTRADAS DE MERCADORIAS OU AQUISIÇÕES DE SERVIÇOS",
  },
  {
    code: 3930,
    text: "Lançamento efetuado a título de entrada de bem sob amparo de regime especial aduaneiro de admissão temporária",
  },
  {
    code: 3949,
    text: "Outra entrada de mercadoria ou prestação de serviço não especificado ",
  },
  {
    code: 5000,
    text: "SAÍDAS OU PRESTAÇÕES DE SERVIÇOS PARA O ESTADO ",
  },
  {
    code: 5100,
    text: "VENDAS DE PRODUÇÃO PRÓPRIA OU DE TERCEIROS",
  },
  {
    code: 5101,
    text: "Venda de produção do estabelecimento",
  },
  {
    code: 5102,
    text: "Venda de mercadoria adquirida ou recebida de terceiros",
  },
  {
    code: 5103,
    text: "Venda de produção do estabelecimento, efetuada fora do estabelecimento",
  },
  {
    code: 5104,
    text: "Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento",
  },
  {
    code: 5105,
    text: "Venda de produção do estabelecimento que não deva por ele transitar",
  },
  {
    code: 5106,
    text: "Venda de mercadoria adquirida ou recebida de terceiros, que não deva por ele transitar",
  },
  {
    code: 5109,
    text: "Venda de produção do estabelecimento, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio",
  },
  {
    code: 5110,
    text: "Venda de mercadoria adquirida ou recebida de terceiros, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio",
  },
  {
    code: 5111,
    text: "Venda de produção do estabelecimento remetida anteriormente em consignação industrial",
  },
  {
    code: 5112,
    text: "Venda de mercadoria adquirida ou recebida de terceiros remetida anteriormente em consignação industrial",
  },
  {
    code: 5113,
    text: "Venda de produção do estabelecimento remetida anteriormente em consignação mercantil",
  },
  {
    code: 5114,
    text: "Venda de mercadoria adquirida ou recebida de terceiros remetida anteriormente em consignação mercantil",
  },
  {
    code: 5115,
    text: "Venda de mercadoria adquirida ou recebida de terceiros, recebida anteriormente em consignação mercantil",
  },
  {
    code: 5116,
    text: "Venda de produção do estabelecimento originada de encomenda para entrega futura",
  },
  {
    code: 5117,
    text: "Venda de mercadoria adquirida ou recebida de terceiros, originada de encomenda para entrega futura",
  },
  {
    code: 5118,
    text: "Venda de produção do estabelecimento entregue ao destinatário por conta e ordem do adquirente originário, em venda à ordem",
  },
  {
    code: 5119,
    text: "Venda de mercadoria adquirida ou recebida de terceiros entregue ao destinatário por conta e ordem do adquirente originário, em venda à ordem",
  },
  {
    code: 5120,
    text: "Venda de mercadoria adquirida ou recebida de terceiros entregue ao destinatário pelo vendedor remetente, em venda à ordem",
  },
  {
    code: 5122,
    text: "Venda de produção do estabelecimento remetida para industrialização, por conta e ordem do adquirente, sem transitar pelo estabelecimento do adquirente",
  },
  {
    code: 5123,
    text: "Venda de mercadoria adquirida ou recebida de terceiros remetida para industrialização, por conta e ordem do adquirente, sem transitar pelo estabelecimento do adquirente",
  },
  {
    code: 5124,
    text: "Industrialização efetuada para outra empresa",
  },
  {
    code: 5125,
    text: "Industrialização efetuada para outra empresa quando a mercadoria recebida para utilização no processo de industrialização não transitar pelo estabelecimento adquirente da mercadoria",
  },
  {
    code: 5150,
    text: "TRANSFERÊNCIAS DE PRODUÇÃO PRÓPRIA OU DE TERCEIROS",
  },
  {
    code: 5151,
    text: "Transferência de produção do estabelecimento",
  },
  {
    code: 5152,
    text: "Transferência de mercadoria adquirida ou recebida de terceiros",
  },
  {
    code: 5153,
    text: "Transferência de energia elétrica",
  },
  {
    code: 5155,
    text: "Transferência de produção do estabelecimento, que não deva por ele transitar",
  },
  {
    code: 5156,
    text: "Transferência de mercadoria adquirida ou recebida de terceiros, que não deva por ele transitar",
  },
  {
    code: 5200,
    text: "DEVOLUÇÕES DE COMPRAS PARA INDUSTRIALIZAÇÃO, COMERCIALIZAÇÃO OU ANULAÇÕES DE VALORES",
  },
  {
    code: 5201,
    text: "Devolução de compra para industrialização ou produção rural",
  },
  {
    code: 5202,
    text: "Devolução de compra para comercialização",
  },
  {
    code: 5205,
    text: "Anulação de valor relativo a aquisição de serviço de comunicação",
  },
  {
    code: 5206,
    text: "Anulação de valor relativo a aquisição de serviço de transporte",
  },
  {
    code: 5207,
    text: "Anulação de valor relativo à compra de energia elétrica",
  },
  {
    code: 5208,
    text: "Devolução de mercadoria recebida em transferência para industrialização ou produção rural",
  },
  {
    code: 5209,
    text: "Devolução de mercadoria recebida em transferência para comercialização",
  },
  {
    code: 5210,
    text: "Devolução de compra para utilização na prestação de serviço sujeitas ao ICMS ou ISSQN",
  },
  {
    code: 5250,
    text: "VENDAS DE ENERGIA ELÉTRICA",
  },
  {
    code: 5251,
    text: "Venda de energia elétrica para distribuição ou comercialização",
  },
  {
    code: 5252,
    text: "Venda de energia elétrica para estabelecimento industrial",
  },
  {
    code: 5253,
    text: "Venda de energia elétrica para estabelecimento comercial",
  },
  {
    code: 5254,
    text: "Venda de energia elétrica para estabelecimento prestador de serviço de transporte",
  },
  {
    code: 5255,
    text: "Venda de energia elétrica para estabelecimento prestador de serviço de comunicação",
  },
  {
    code: 5256,
    text: "Venda de energia elétrica para estabelecimento de produtor rural",
  },
  {
    code: 5257,
    text: "Venda de energia elétrica para consumo por demanda contratada",
  },
  {
    code: 5258,
    text: "Venda de energia elétrica a não contribuinte ",
  },
  {
    code: 5300,
    text: "PRESTAÇÕES DE SERVIÇOS DE COMUNICAÇÃO",
  },
  {
    code: 5301,
    text: "Prestação de serviço de comunicação para execução de serviço da mesma natureza",
  },
  {
    code: 5302,
    text: "Prestação de serviço de comunicação a estabelecimento industrial",
  },
  {
    code: 5303,
    text: "Prestação de serviço de comunicação a estabelecimento comercial",
  },
  {
    code: 5304,
    text: "Prestação de serviço de comunicação a estabelecimento de prestador de serviço de transporte",
  },
  {
    code: 5305,
    text: "Prestação de serviço de comunicação a estabelecimento de geradora ou de distribuidora de energia elétrica",
  },
  {
    code: 5306,
    text: "Prestação de serviço de comunicação a estabelecimento de produtor rural",
  },
  {
    code: 5307,
    text: "Prestação de serviço de comunicação a não contribuinte ",
  },
  {
    code: 5350,
    text: "PRESTAÇÕES DE SERVIÇOS DE TRANSPORTE",
  },
  {
    code: 5351,
    text: "Prestação de serviço de transporte para execução de serviço da mesma natureza",
  },
  {
    code: 5352,
    text: "Prestação de serviço de transporte a estabelecimento industrial",
  },
  {
    code: 5353,
    text: "Prestação de serviço de transporte a estabelecimento comercial",
  },
  {
    code: 5354,
    text: "Prestação de serviço de transporte a estabelecimento de prestador de serviço de comunicação",
  },
  {
    code: 5355,
    text: "Prestação de serviço de transporte a estabelecimento de geradora ou de distribuidora de energia elétrica",
  },
  {
    code: 5356,
    text: "Prestação de serviço de transporte a estabelecimento de produtor rural",
  },
  {
    code: 5357,
    text: "Prestação de serviço de transporte a não contribuinte",
  },
  {
    code: 5359,
    text: "Prestação de serviço de transporte a contribuinte ou a não contribuinte quando a mercadoria transportada está dispensada de emissão de nota fiscal",
  },
  {
    code: 5360,
    text: "Prestação de serviço de transporte a contribuinte substituto em relação ao serviço de transporte",
  },
  {
    code: 5400,
    text: "SAÍDAS DE MERCADORIAS SUJEITAS AO REGIME DE SUBSTITUIÇÃO TRIBUTÁRIA",
  },
  {
    code: 5401,
    text: "Venda de produção do estabelecimento em operação com produto sujeito ao regime de substituição tributária, na condição de contribuinte substituto",
  },
  {
    code: 5402,
    text: "Venda de produção do estabelecimento de produto sujeito ao regime de substituição tributária, em operação entre contribuintes substitutos do mesmo produto",
  },
  {
    code: 5403,
    text: "Venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária, na condição de contribuinte substituto",
  },
  {
    code: 5405,
    text: "Venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária, na condição de contribuinte substituído",
  },
  {
    code: 5408,
    text: "Transferência de produção do estabelecimento em operação com produto sujeito ao regime de substituição tributária",
  },
  {
    code: 5409,
    text: "Transferência de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 5410,
    text: "Devolução de compra para industrialização ou produção rural em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 5411,
    text: "Devolução de compra para comercialização em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 5412,
    text: "Devolução de bem do ativo imobilizado, em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 5413,
    text: "Devolução de mercadoria destinada ao uso ou consumo, em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 5414,
    text: "Remessa de produção do estabelecimento para venda fora do estabelecimento em operação com produto sujeito ao regime de substituição tributária",
  },
  {
    code: 5415,
    text: "Remessa de mercadoria adquirida ou recebida de terceiros para venda fora do estabelecimento, em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 5450,
    text: "SISTEMAS DE INTEGRAÇÃO",
  },
  {
    code: 5451,
    text: "Remessa de animal e de insumo para estabelecimento produtor",
  },
  {
    code: 5500,
    text: "REMESSAS COM FIM ESPECÍFICO DE EXPORTAÇÃO E EVENTUAIS DEVOLUÇÕES",
  },
  {
    code: 5501,
    text: "Remessa de produção do estabelecimento, com fim específico de exportação 5.502 - Remessa de mercadoria adquirida ou recebida de terceiros, com fim específico de exportação",
  },
  {
    code: 5503,
    text: "Devolução de mercadoria recebida com fim específico de exportação",
  },
  {
    code: 5504,
    text: "Remessa de mercadorias para formação de lote de exportação, de produtos industrializados ou produzidos pelo próprio estabelecimento",
  },
  {
    code: 5505,
    text: "Remessa de mercadorias, adquiridas ou recebidas de terceiros, para formação de lote de exportação ",
  },
  {
    code: 5550,
    text: "OPERAÇÕES COM BENS DE ATIVO IMOBILIZADO E MATERIAIS PARA USO OU CONSUMO",
  },
  {
    code: 5551,
    text: "Venda de bem do ativo imobilizado",
  },
  {
    code: 5552,
    text: "Transferência de bem do ativo imobilizado",
  },
  {
    code: 5553,
    text: "Devolução de compra de bem para o ativo imobilizado",
  },
  {
    code: 5554,
    text: "Remessa de bem do ativo imobilizado para uso fora do estabelecimento",
  },
  {
    code: 5555,
    text: "Devolução de bem do ativo imobilizado de terceiro, recebido para uso no estabelecimento",
  },
  {
    code: 5556,
    text: "Devolução de compra de material de uso ou consumo",
  },
  {
    code: 5557,
    text: "Transferência de material de uso ou consumo",
  },
  {
    code: 5600,
    text: "CRÉDITOS E RESSARCIMENTOS DE ICMS",
  },
  {
    code: 5601,
    text: "Transferência de crédito de ICMS acumulado",
  },
  {
    code: 5602,
    text: "Transferência de saldo credor de ICMS para outro estabelecimento da mesma empresa, destinado à compensação de saldo devedor de ICMS",
  },
  {
    code: 5603,
    text: "Ressarcimento de ICMS retido por substituição tributária",
  },
  {
    code: 5605,
    text: "Transferência de saldo devedor de ICMS de outro estabelecimento da mesma empresa",
  },
  {
    code: 5606,
    text: "Utilização de saldo credor de ICMS para extinção por compensação de débitos fiscais",
  },
  {
    code: 5651,
    text: "Venda de combustível ou lubrificante de produção do estabelecimento destinado à industrialização subseqüente",
  },
  {
    code: 5652,
    text: "Venda de combustível ou lubrificante de produção do estabelecimento destinado à comercialização",
  },
  {
    code: 5653,
    text: "Venda de combustível ou lubrificante de produção do estabelecimento destinado a consumidor ou usuário final",
  },
  {
    code: 5654,
    text: "Venda de combustível ou lubrificante adquirido ou recebido de terceiros destinado à industrialização subseqüente",
  },
  {
    code: 5655,
    text: "Venda de combustível ou lubrificante adquirido ou recebido de terceiros destinado à comercialização",
  },
  {
    code: 5656,
    text: "Venda de combustível ou lubrificante adquirido ou recebido de terceiros destinado a consumidor ou usuário final",
  },
  {
    code: 5657,
    text: "Remessa de combustível ou lubrificante adquirido ou recebido de terceiros para venda fora do estabelecimento",
  },
  {
    code: 5658,
    text: "Transferência de combustível ou lubrificante de produção do estabelecimento",
  },
  {
    code: 5659,
    text: "Transferência de combustível ou lubrificante adquirido ou recebido de terceiro",
  },
  {
    code: 5660,
    text: "Devolução de compra de combustível ou lubrificante adquirido para industrialização subseqüente",
  },
  {
    code: 5661,
    text: "Devolução de compra de combustível ou lubrificante adquirido para comercialização",
  },
  {
    code: 5662,
    text: "Devolução de compra de combustível ou lubrificante adquirido por consumidor ou usuário final",
  },
  {
    code: 5663,
    text: "Remessa para armazenagem de combustível ou lubrificante",
  },
  {
    code: 5664,
    text: "Retorno de combustível ou lubrificante recebido para armazenagem",
  },
  {
    code: 5665,
    text: "Retorno simbólico de combustível ou lubrificante recebido para armazenagem",
  },
  {
    code: 5666,
    text: "Remessa por conta e ordem de terceiros de combustível ou lubrificante recebido para armazenagem ",
  },
  {
    code: 5900,
    text: "OUTRAS SAÍDAS DE MERCADORIAS OU PRESTAÇÕES DE SERVIÇOS",
  },
  {
    code: 5901,
    text: "Remessa para industrialização por encomenda",
  },
  {
    code: 5902,
    text: "Retorno de mercadoria utilizada na industrialização por encomenda",
  },
  {
    code: 5903,
    text: "Retorno de mercadoria recebida para industrialização e não aplicada no referido processo",
  },
  {
    code: 5904,
    text: "Remessa para venda fora do estabelecimento",
  },
  {
    code: 5905,
    text: "Remessa para depósito fechado ou armazém geral",
  },
  {
    code: 5906,
    text: "Retorno de mercadoria depositada em depósito fechado ou armazém geral",
  },
  {
    code: 5907,
    text: "Retorno simbólico de mercadoria depositada em depósito fechado ou armazém geral",
  },
  {
    code: 5908,
    text: "Remessa de bem por conta de contrato de comodato",
  },
  {
    code: 5909,
    text: "Retorno de bem recebido por conta de contrato de comodato",
  },
  {
    code: 5910,
    text: "Remessa em bonificação, doação ou brinde",
  },
  {
    code: 5911,
    text: "Remessa de amostra grátis",
  },
  {
    code: 5912,
    text: "Remessa de mercadoria ou bem para demonstração",
  },
  {
    code: 5913,
    text: "Retorno de mercadoria ou bem recebido para demonstração",
  },
  {
    code: 5914,
    text: "Remessa de mercadoria ou bem para exposição ou feira",
  },
  {
    code: 5915,
    text: "Remessa de mercadoria ou bem para conserto ou reparo",
  },
  {
    code: 5916,
    text: "Retorno de mercadoria ou bem recebido para conserto ou reparo",
  },
  {
    code: 5917,
    text: "Remessa de mercadoria em consignação mercantil ou industrial",
  },
  {
    code: 5918,
    text: "Devolução de mercadoria recebida em consignação mercantil ou industrial",
  },
  {
    code: 5919,
    text: "Devolução simbólica de mercadoria vendida ou utilizada em processo industrial, recebida anteriormente em consignação mercantil ou industrial",
  },
  {
    code: 5920,
    text: "Remessa de vasilhame ou sacaria",
  },
  {
    code: 5921,
    text: "Devolução de vasilhame ou sacaria",
  },
  {
    code: 5922,
    text: "Lançamento efetuado a título de simples faturamento decorrente de venda para entrega futura",
  },
  {
    code: 5923,
    text: "Remessa de mercadoria por conta e ordem de terceiros, em venda à ordem",
  },
  {
    code: 5924,
    text: "Remessa para industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente",
  },
  {
    code: 5925,
    text: "Retorno de mercadoria recebida para industrialização por conta e ordem do adquirente da mercadoria, quando aquela não transitar pelo estabelecimento do adquirente",
  },
  {
    code: 5926,
    text: "Lançamento efetuado a título de reclassificação de mercadoria decorrente de formação de kit ou de sua desagregação",
  },
  {
    code: 5927,
    text: "Lançamento efetuado a título de baixa de estoque decorrente de perda, roubo ou deterioração",
  },
  {
    code: 5928,
    text: "Lançamento efetuado a título de baixa de estoque decorrente do encerramento da atividade da empresa",
  },
  {
    code: 5929,
    text: "Lançamento efetuado em decorrência de emissão de documento fiscal relativo a operação ou prestação também registrada em equipamento Emissor de Cupom Fiscal - ECF",
  },
  {
    code: 5931,
    text: "Lançamento efetuado em decorrência da responsabilidade de retenção do imposto por substituição tributária, atribuída ao remetente ou alienante da mercadoria, pelo serviço de transporte realizado por transportador autônomo ou por transportador não inscrito na unidade da Federação onde iniciado o serviço",
  },
  {
    code: 5932,
    text: "Prestação de serviço de transporte iniciada em unidade da Federação diversa daquela onde inscrito o prestador",
  },
  {
    code: 5933,
    text: "Prestação de serviço tributado pelo ISSQN",
  },
  {
    code: 5949,
    text: "Outra saída de mercadoria ou prestação de serviço não especificado ",
  },
  {
    code: 6000,
    text: "SAÍDAS OU PRESTAÇÕES DE SERVIÇOS PARA OUTROS ESTADOS ",
  },
  {
    code: 6100,
    text: "VENDAS DE PRODUÇÃO PRÓPRIA OU DE TERCEIROS",
  },
  {
    code: 6101,
    text: "Venda de produção do estabelecimento",
  },
  {
    code: 6102,
    text: "Venda de mercadoria adquirida ou recebida de terceiros",
  },
  {
    code: 6103,
    text: "Venda de produção do estabelecimento, efetuada fora do estabelecimento",
  },
  {
    code: 6104,
    text: "Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento",
  },
  {
    code: 6105,
    text: "Venda de produção do estabelecimento que não deva por ele transitar",
  },
  {
    code: 6106,
    text: "Venda de mercadoria adquirida ou recebida de terceiros, que não deva por ele transitar",
  },
  {
    code: 6107,
    text: "Venda de produção do estabelecimento, destinada a não contribuinte",
  },
  {
    code: 6108,
    text: "Venda de mercadoria adquirida ou recebida de terceiros, destinada a não contribuinte",
  },
  {
    code: 6109,
    text: "Venda de produção do estabelecimento, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio",
  },
  {
    code: 6110,
    text: "Venda de mercadoria adquirida ou recebida de terceiros, destinada à Zona Franca de Manaus ou Áreas de Livre Comércio",
  },
  {
    code: 6111,
    text: "Venda de produção do estabelecimento remetida anteriormente em consignação industrial",
  },
  {
    code: 6112,
    text: "Venda de mercadoria adquirida ou recebida de Terceiros remetida anteriormente em consignação industrial",
  },
  {
    code: 6113,
    text: "Venda de produção do estabelecimento remetida anteriormente em consignação mercantil",
  },
  {
    code: 6114,
    text: "Venda de mercadoria adquirida ou recebida de terceiros remetida anteriormente em consignação mercantil",
  },
  {
    code: 6115,
    text: "Venda de mercadoria adquirida ou recebida de terceiros, recebida anteriormente em consignação mercantil",
  },
  {
    code: 6116,
    text: "Venda de produção do estabelecimento originada de encomenda para entrega futura",
  },
  {
    code: 6117,
    text: "Venda de mercadoria adquirida ou recebida de terceiros, originada de encomenda para entrega futura",
  },
  {
    code: 6118,
    text: "Venda de produção do estabelecimento entregue ao destinatário por conta e ordem do adquirente originário, em venda à ordem",
  },
  {
    code: 6119,
    text: "Venda de mercadoria adquirida ou recebida de terceiros entregue ao destinatário por conta e ordem do adquirente originário, em venda à ordem",
  },
  {
    code: 6120,
    text: "Venda de mercadoria adquirida ou recebida de terceiros entregue ao destinatário pelo vendedor remetente, em venda à ordem",
  },
  {
    code: 6122,
    text: "Venda de produção do estabelecimento remetida para industrialização, por conta e ordem do adquirente, sem transitar pelo estabelecimento do adquirente",
  },
  {
    code: 6123,
    text: "Venda de mercadoria adquirida ou recebida de terceiros remetida para industrialização, por conta e ordem do adquirente, sem transitar pelo estabelecimento do adquirente",
  },
  {
    code: 6124,
    text: "Industrialização efetuada para outra empresa",
  },
  {
    code: 6125,
    text: "Industrialização efetuada para outra empresa quando a mercadoria recebida para utilização no processo de industrialização não transitar pelo estabelecimento adquirente da mercadoria",
  },
  {
    code: 6150,
    text: "TRANSFERÊNCIAS DE PRODUÇÃO PRÓPRIA OU DE TERCEIROS",
  },
  {
    code: 6151,
    text: "Transferência de produção do estabelecimento",
  },
  {
    code: 6152,
    text: "Transferência de mercadoria adquirida ou recebida de terceiros",
  },
  {
    code: 6153,
    text: "Transferência de energia elétrica 6.155 - Transferência de produção do estabelecimento, que não deva por ele transitar",
  },
  {
    code: 6156,
    text: "Transferência de mercadoria adquirida ou recebida de terceiros, que não deva por ele transitar",
  },
  {
    code: 6200,
    text: "DEVOLUÇÕES DE COMPRAS PARA INDUSTRIALIZAÇÃO, COMERCIALIZAÇÃO OU ANULAÇÕES DE VALORES",
  },
  {
    code: 6201,
    text: "Devolução de compra para industrialização ou produção rural",
  },
  {
    code: 6202,
    text: "Devolução de compra para comercialização",
  },
  {
    code: 6205,
    text: "Anulação de valor relativo a aquisição de serviço de comunicação",
  },
  {
    code: 6206,
    text: "Anulação de valor relativo a aquisição de serviço de transporte",
  },
  {
    code: 6207,
    text: "Anulação de valor relativo à compra de energia elétrica",
  },
  {
    code: 6208,
    text: "Devolução de mercadoria recebida em transferência para industrialização ou produção rural",
  },
  {
    code: 6209,
    text: "Devolução de mercadoria recebida em transferência para comercialização",
  },
  {
    code: 6210,
    text: "Devolução de compra para utilização na prestação de serviço ",
  },
  {
    code: 6250,
    text: "VENDAS DE ENERGIA ELÉTRICA",
  },
  {
    code: 6251,
    text: "Venda de energia elétrica para distribuição ou comercialização",
  },
  {
    code: 6252,
    text: "Venda de energia elétrica para estabelecimento industrial",
  },
  {
    code: 6253,
    text: "Venda de energia elétrica para estabelecimento comercial",
  },
  {
    code: 6254,
    text: "Venda de energia elétrica para estabelecimento prestador de serviço de transporte",
  },
  {
    code: 6255,
    text: "Venda de energia elétrica para estabelecimento prestador de serviço de comunicação",
  },
  {
    code: 6256,
    text: "Venda de energia elétrica para estabelecimento de produtor rural",
  },
  {
    code: 6257,
    text: "Venda de energia elétrica para consumo por demanda contratada",
  },
  {
    code: 6258,
    text: "Venda de energia elétrica a não contribuinte",
  },
  {
    code: 6300,
    text: "PRESTAÇÕES DE SERVIÇOS DE COMUNICAÇÃO",
  },
  {
    code: 6301,
    text: "Prestação de serviço de comunicação para execução de serviço da mesma natureza",
  },
  {
    code: 6302,
    text: "Prestação de serviço de comunicação a estabelecimento industrial",
  },
  {
    code: 6303,
    text: "Prestação de serviço de comunicação a estabelecimento comercial",
  },
  {
    code: 6304,
    text: "Prestação de serviço de comunicação a estabelecimento de prestador de serviço de transporte",
  },
  {
    code: 6305,
    text: "Prestação de serviço de comunicação a estabelecimento de geradora ou de distribuidora de energia elétrica",
  },
  {
    code: 6306,
    text: "Prestação de serviço de comunicação a estabelecimento de produtor rural",
  },
  {
    code: 6307,
    text: "Prestação de serviço de comunicação a não contribuinte",
  },
  {
    code: 6350,
    text: "PRESTAÇÕES DE SERVIÇOS DE TRANSPORTE",
  },
  {
    code: 6351,
    text: "Prestação de serviço de transporte para execução de serviço da mesma natureza",
  },
  {
    code: 6352,
    text: "Prestação de serviço de transporte a estabelecimento industrial",
  },
  {
    code: 6353,
    text: "Prestação de serviço de transporte a estabelecimento comercial",
  },
  {
    code: 6354,
    text: "Prestação de serviço de transporte a estabelecimento de prestador de serviço de comunicação",
  },
  {
    code: 6355,
    text: "Prestação de serviço de transporte a estabelecimento de geradora ou de distribuidora de energia elétrica",
  },
  {
    code: 6356,
    text: "Prestação de serviço de transporte a estabelecimento de produtor rural",
  },
  {
    code: 6357,
    text: "Prestação de serviço de transporte a não contribuinte",
  },
  {
    code: 6359,
    text: "Prestação de serviço de transporte a contribuinte ou a não contribuinte quando a mercadoria transportada está dispensada de emissão de nota fiscal",
  },
  {
    code: 6400,
    text: "SAÍDAS DE MERCADORIAS SUJEITAS AO REGIME DE SUBSTITUIÇÃO TRIBUTÁRIA",
  },
  {
    code: 6401,
    text: "Venda de produção do estabelecimento em operação com produto sujeito ao regime de substituição tributária, na condição de contribuinte substituto",
  },
  {
    code: 6402,
    text: "Venda de produção do estabelecimento de produto sujeito ao regime de substituição tributária, em operação entre contribuintes substitutos do mesmo produto",
  },
  {
    code: 6403,
    text: "Venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária, na condição de contribuinte substituto",
  },
  {
    code: 6404,
    text: "Venda de mercadoria sujeita ao regime de substituição tributária, cujo imposto já tenha sido retido anteriormente",
  },
  {
    code: 6408,
    text: "Transferência de produção do estabelecimento em operação com produto sujeito ao regime de substituição tributária",
  },
  {
    code: 6409,
    text: "Transferência de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 6410,
    text: "Devolução de compra para industrialização ou produção rural em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 6411,
    text: "Devolução de compra para comercialização em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 6412,
    text: "Devolução de bem do ativo imobilizado, em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 6413,
    text: "Devolução de mercadoria destinada ao uso ou consumo, em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 6414,
    text: "Remessa de produção do estabelecimento para venda fora do estabelecimento em operação com produto sujeito ao regime de substituição tributária",
  },
  {
    code: 6415,
    text: "Remessa de mercadoria adquirida ou recebida de terceiros para venda fora do estabelecimento, em operação com mercadoria sujeita ao regime de substituição tributária",
  },
  {
    code: 6500,
    text: "REMESSAS COM FIM ESPECÍFICO DE EXPORTAÇÃO E EVENTUAIS DEVOLUÇÕES",
  },
  {
    code: 6501,
    text: "Remessa de produção do estabelecimento, com fim específico de exportação",
  },
  {
    code: 6502,
    text: "Remessa de mercadoria adquirida ou recebida de terceiros, com fim específico de exportação",
  },
  {
    code: 6503,
    text: "Devolução de mercadoria recebida com fim específico de exportação",
  },
  {
    code: 6504,
    text: "Remessa de mercadorias para formação de lote de exportação, de produtos industrializados ou produzidos pelo próprio estabelecimento",
  },
  {
    code: 6505,
    text: "Remessa de mercadorias, adquiridas ou recebidas de terceiros, para formação de lote de exportação",
  },
  {
    code: 6550,
    text: "OPERAÇÕES COM BENS DE ATIVO IMOBILIZADO E MATERIAIS PARA USO OU CONSUMO",
  },
  {
    code: 6551,
    text: "Venda de bem do ativo imobilizado",
  },
  {
    code: 6552,
    text: "Transferência de bem do ativo imobilizado",
  },
  {
    code: 6553,
    text: "Devolução de compra de bem para o ativo imobilizado",
  },
  {
    code: 6554,
    text: "Remessa de bem do ativo imobilizado para uso fora do estabelecimento",
  },
  {
    code: 6555,
    text: "Devolução de bem do ativo imobilizado de terceiro, recebido para uso no estabelecimento",
  },
  {
    code: 6556,
    text: "Devolução de compra de material de uso ou consumo",
  },
  {
    code: 6557,
    text: "Transferência de material de uso ou consumo",
  },
  {
    code: 6600,
    text: "CRÉDITOS E RESSARCIMENTOS DE ICMS",
  },
  {
    code: 6603,
    text: "Ressarcimento de ICMS retido por substituição tributária",
  },
  {
    code: 6651,
    text: "Venda de combustível ou lubrificante de produção do estabelecimento destinado à industrialização subseqüente",
  },
  {
    code: 6652,
    text: "Venda de combustível ou lubrificante de produção do estabelecimento destinado à comercialização",
  },
  {
    code: 6653,
    text: "Venda de combustível ou lubrificante de produção do estabelecimento destinado a consumidor ou usuário final",
  },
  {
    code: 6654,
    text: "Venda de combustível ou lubrificante adquirido ou recebido de terceiros destinado à industrialização subseqüente",
  },
  {
    code: 6655,
    text: "Venda de combustível ou lubrificante adquirido ou recebido de terceiros destinado à comercialização",
  },
  {
    code: 6656,
    text: "Venda de combustível ou lubrificante adquirido ou recebido de terceiros destinado a consumidor ou usuário final",
  },
  {
    code: 6657,
    text: "Remessa de combustível ou lubrificante adquirido ou recebido de terceiros para venda fora do estabelecimento",
  },
  {
    code: 6658,
    text: "Transferência de combustível ou lubrificante de produção do estabelecimento",
  },
  {
    code: 6659,
    text: "Transferência de combustível ou lubrificante adquirido ou recebido de terceiro",
  },
  {
    code: 6660,
    text: "Devolução de compra de combustível ou lubrificante adquirido para industrialização subseqüente",
  },
  {
    code: 6661,
    text: "Devolução de compra de combustível ou lubrificante adquirido para comercialização",
  },
  {
    code: 6662,
    text: "Devolução de compra de combustível ou lubrificante adquirido por consumidor ou usuário final",
  },
  {
    code: 6663,
    text: "Remessa para armazenagem de combustível ou lubrificante",
  },
  {
    code: 6664,
    text: "Retorno de combustível ou lubrificante recebido para armazenagem",
  },
  {
    code: 6665,
    text: "Retorno simbólico de combustível ou lubrificante recebido para armazenagem",
  },
  {
    code: 6666,
    text: "Remessa por conta e ordem de terceiros de combustível ou lubrificante recebido para armazenagem",
  },
  {
    code: 6900,
    text: "OUTRAS SAÍDAS DE MERCADORIAS OU PRESTAÇÕES DE SERVIÇOS",
  },
  {
    code: 6901,
    text: "Remessa para industrialização por encomenda",
  },
  {
    code: 6902,
    text: "Retorno de mercadoria utilizada na industrialização por encomenda",
  },
  {
    code: 6903,
    text: "Retorno de mercadoria recebida para industrialização e não aplicada no referido processo",
  },
  {
    code: 6904,
    text: "Remessa para venda fora do estabelecimento",
  },
  {
    code: 6905,
    text: "Remessa para depósito fechado ou armazém geral",
  },
  {
    code: 6906,
    text: "Retorno de mercadoria depositada em depósito fechado ou armazém geral",
  },
  {
    code: 6907,
    text: "Retorno simbólico de mercadoria depositada em depósito fechado ou armazém geral",
  },
  {
    code: 6908,
    text: "Remessa de bem por conta de contrato de comodato",
  },
  {
    code: 6909,
    text: "Retorno de bem recebido por conta de contrato de comodato",
  },
  {
    code: 6910,
    text: "Remessa em bonificação, doação ou brinde",
  },
  {
    code: 6911,
    text: "Remessa de amostra grátis",
  },
  {
    code: 6912,
    text: "Remessa de mercadoria ou bem para demonstração 6.913 - Retorno de mercadoria ou bem recebido para demonstração",
  },
  {
    code: 6914,
    text: "Remessa de mercadoria ou bem para exposição ou feira",
  },
  {
    code: 6915,
    text: "Remessa de mercadoria ou bem para conserto ou reparo",
  },
  {
    code: 6916,
    text: "Retorno de mercadoria ou bem recebido para conserto ou reparo",
  },
  {
    code: 6917,
    text: "Remessa de mercadoria em consignação mercantil ou industrial",
  },
  {
    code: 6918,
    text: "Devolução de mercadoria recebida em consignação mercantil ou industrial",
  },
  {
    code: 6919,
    text: "Devolução simbólica de mercadoria vendida ou utilizada em processo industrial, recebida anteriormente em consignação mercantil ou industrial",
  },
  {
    code: 6920,
    text: "Remessa de vasilhame ou sacaria",
  },
  {
    code: 6921,
    text: "Devolução de vasilhame ou sacaria",
  },
  {
    code: 6922,
    text: "Lançamento efetuado a título de simples faturamento decorrente de venda para entrega futura",
  },
  {
    code: 6923,
    text: "Remessa de mercadoria por conta e ordem de terceiros, em venda à ordem",
  },
  {
    code: 6924,
    text: "Remessa para industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente",
  },
  {
    code: 6925,
    text: "Retorno de mercadoria recebida para industrialização por conta e ordem do adquirente da mercadoria, quando aquela não transitar pelo estabelecimento do adquirente",
  },
  {
    code: 6929,
    text: "Lançamento efetuado em decorrência de emissão de documento fiscal relativo a operação ou prestação também registrada em equipamento Emissor de Cupom Fiscal - ECF",
  },
  {
    code: 6931,
    text: "Lançamento efetuado em decorrência da responsabilidade de retenção do imposto por substituição tributária, atribuída ao remetente ou alienante da mercadoria, pelo serviço de transporte realizado por transportador autônomo ou por transportador não inscrito na unidade da Federação onde iniciado o serviço",
  },
  {
    code: 6932,
    text: "Prestação de serviço de transporte iniciada em unidade da Federação diversa daquela onde inscrito o prestador",
  },
  {
    code: 6933,
    text: "Prestação de serviço tributado pelo ISSQN",
  },
  {
    code: 6949,
    text: "Outra saída de mercadoria ou prestação de serviço não especificado",
  },
  {
    code: 7000,
    text: "SAÍDAS OU PRESTAÇÕES DE SERVIÇOS PARA O EXTERIOR ",
  },
  {
    code: 7100,
    text: "VENDAS DE PRODUÇÃO PRÓPRIA OU DE TERCEIROS",
  },
  {
    code: 7101,
    text: "Venda de produção do estabelecimento",
  },
  {
    code: 7102,
    text: "Venda de mercadoria adquirida ou recebida de terceiros",
  },
  {
    code: 7105,
    text: "Venda de produção do estabelecimento, que não deva por ele transitar",
  },
  {
    code: 7106,
    text: "Venda de mercadoria adquirida ou recebida de terceiros, que não deva por ele transitar",
  },
  {
    code: 7127,
    text: "Venda de produção do estabelecimento sob o regime de ",
  },
  {
    code: 7200,
    text: "DEVOLUÇÕES DE COMPRAS PARA INDUSTRIALIZAÇÃO, COMERCIALIZAÇÃO OU ANULAÇÕES DE VALORES",
  },
  {
    code: 7201,
    text: "Devolução de compra para industrialização ou produção rural",
  },
  {
    code: 7202,
    text: "Devolução de compra para comercialização",
  },
  {
    code: 7205,
    text: "Anulação de valor relativo à aquisição de serviço de comunicação",
  },
  {
    code: 7206,
    text: "Anulação de valor relativo a aquisição de serviço de transporte",
  },
  {
    code: 7207,
    text: "Anulação de valor relativo à compra de energia elétrica",
  },
  {
    code: 7210,
    text: "Devolução de compra para utilização na prestação de serviço",
  },
  {
    code: 7211,
    text: "Devolução de compras para industrialização sob o regime de drawback",
  },
  {
    code: 7250,
    text: "VENDAS DE ENERGIA ELÉTRICA",
  },
  {
    code: 7251,
    text: "Venda de energia elétrica para o exterior ",
  },
  {
    code: 7300,
    text: "PRESTAÇÕES DE SERVIÇOS DE COMUNICAÇÃO",
  },
  {
    code: 7301,
    text: "Prestação de serviço de comunicação para execução de serviço da mesma natureza ",
  },
  {
    code: 7350,
    text: "PRESTAÇÕES DE SERVIÇO DE TRANSPORTE",
  },
  {
    code: 7358,
    text: "Prestação de serviço de transporte ",
  },
  {
    code: 7500,
    text: "EXPORTAÇÃO DE MERCADORIAS RECEBIDAS COM FIM ESPECÍFICO DE EXPORTAÇÃO",
  },
  {
    code: 7501,
    text: "Exportação de mercadorias recebidas com fim específico de exportação",
  },
  {
    code: 7550,
    text: "OPERAÇÕES COM BENS DE ATIVO IMOBILIZADO E MATERIAIS PARA USO OU CONSUMO",
  },
  {
    code: 7551,
    text: "Venda de bem do ativo imobilizado",
  },
  {
    code: 7553,
    text: "Devolução de compra de bem para o ativo imobilizado",
  },
  {
    code: 7556,
    text: "Devolução de compra de material de uso ou consumo",
  },
  {
    code: 7651,
    text: "Venda de combustível ou lubrificante de produção do estabelecimento",
  },
  {
    code: 7654,
    text: "Venda de combustível ou lubrificante adquirido ou recebido de terceiros",
  },
  {
    code: 7900,
    text: "OUTRAS SAÍDAS DE MERCADORIAS OU PRESTAÇÕES DE SERVIÇOS",
  },
  {
    code: 7930,
    text: "Lançamento efetuado atítulo de devolução de bem cuja entrada tenha ocorrido sob amparo de regime especial aduaneiro de admissão temporária",
  },
  {
    code: 7949,
    text: "Outra saída de mercadoria ou prestação de serviço não especificado",
  },
];
